import _get from 'lodash/get';
import useRouter from 'use-react-router';

const useShouldShowEmptyState = ({ table }) => {
  const { topFilters } = table;
  const { match } = useRouter();
  const { path } = match;
  const isMapView = path?.includes('map');

  const portAreaIds = _get(
    topFilters.find(f => f.name === 'port_area_id'),
    'value'
  );
  const portTypeIds = _get(
    topFilters.find(f => f.name === 'country_id'),
    'value'
  );

  return isMapView && !portAreaIds && !portTypeIds;
};

export default useShouldShowEmptyState;
